import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "statusInput"]
  static values = { current: String }

  // Button class configurations for each status
  static statusClasses = {
    todo: { active: "btn-ghost-sapphire", inactive: "btn-ghost text-sapphire" },
    in_progress: {
      active: "btn-ghost-warning",
      inactive: "btn-ghost text-warning"
    },
    completed: { active: "btn-sage", inactive: "btn-ghost text-success" },
    cancelled: { active: "btn-danger", inactive: "btn-ghost text-danger" }
  }

  select(event) {
    const button = event.currentTarget
    const newStatus = button.dataset.statusParam

    // Skip if already active
    if (newStatus === this.currentValue) return

    // Update visual state immediately (optimistic UI)
    this.updateButtons(newStatus)

    // Update hidden input and submit form
    this.statusInputTarget.value = newStatus
    this.formTarget.requestSubmit()

    // Update current value
    this.currentValue = newStatus

    window.dispatchEvent(
      new CustomEvent("toast:show", {
        detail: {
          message: `Task marked as ${newStatus}`,
          type: "success"
        }
      })
    )
  }

  updateButtons(activeStatus) {
    const buttons = this.element.querySelectorAll(".btn-group .btn")

    buttons.forEach((btn) => {
      const status = btn.dataset.statusParam
      const config = this.constructor.statusClasses[status]
      if (!config) return

      // Remove all status-related classes
      btn.classList.remove(
        "btn-ghost",
        "btn-ghost-sapphire",
        "btn-ghost-warning",
        "btn-sage",
        "btn-danger",
        "btn-active",
        "text-sapphire",
        "text-warning",
        "text-success",
        "text-danger"
      )

      // Apply active or inactive classes
      const classes = status === activeStatus ? config.active : config.inactive
      classes.split(" ").forEach((cls) => btn.classList.add(cls))
    })
  }
}
